import { Reveal } from "./Reveal";

const chapters = [
    {
        n: "01",
        title: "Set your rules once",
        body: "Choose Rapido, Porter, or both. Pick your order type, pickup radius and drop-off range. RapidClick remembers everything — you never configure it twice.",
    },
    {
        n: "02",
        title: "Eyes on the road",
        body: "No more staring at your phone at signals. RapidClick watches the screen so you can watch the road — and get every captain home safe.",
    },
    {
        n: "03",
        title: "Millisecond reflexes",
        body: "The moment a matching order appears, it is accepted in about 32 milliseconds. Before anyone else even sees it on their screen.",
    },
];

export default function Manifesto() {
    return (
        <section id="how" data-testid="manifesto-section" className="py-16 md:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <Reveal>
                    <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-brand">
                        How it works
                    </p>
                    <h2 className="mt-4 font-display text-4xl font-bold tracking-tight text-ink md:text-6xl">
                        Set it once. It works every day.
                    </h2>
                    <p className="mt-5 max-w-lg text-base leading-relaxed text-mute">
                        Three simple steps in the app — then RapidClick accepts matching rides for
                        you automatically, in milliseconds.
                    </p>
                </Reveal>

                <div className="mt-14 md:mt-20">
                    {chapters.map((c, i) => (
                        <Reveal key={c.n} delay={i * 0.08}>
                            <div
                                data-testid={`manifesto-chapter-${c.n}`}
                                className={`group grid grid-cols-1 gap-3 border-t border-line py-8 md:grid-cols-[100px_1fr_1fr] md:gap-10 md:py-14 ${
                                    i === chapters.length - 1 ? "border-b" : ""
                                }`}
                            >
                                <span className="font-mono text-sm text-brand">{c.n}</span>
                                <h3 className="font-display text-3xl font-bold tracking-tight text-ink transition-transform duration-500 group-hover:translate-x-2 md:text-4xl">
                                    {c.title}
                                </h3>
                                <p className="max-w-md text-sm leading-relaxed text-mute md:text-base">
                                    {c.body}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
